import { useState } from "react";
import { createPortal } from "react-dom";
import { Phone, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { useT } from "../../lib/i18n";
import { track } from "../../lib/track";

export function CallbackButton({ className = "k-btn-outline k-btn-sm", label }) {
  const { t } = useT();
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ name: "", phone: "", need: "" });
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (ev) => {
    ev.preventDefault();
    setBusy(true);
    try {
      await api.post("/public/callback", { ...f, page: window.location.pathname });
      setDone(true); track("callback_submit", {});
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <>
      <button type="button" className={className} onClick={() => { setOpen(true); setDone(false); setF({ name: "", phone: "", need: "" }); track("callback_open", {}); }} data-testid="callback-open"><Phone size={14} /> {label || t("Être rappelé")}</button>
      {open && createPortal(
        <div className="fixed inset-0 z-[90] bg-black/40 grid place-items-center p-4" onClick={() => setOpen(false)} data-testid="callback-modal">
          <form onSubmit={submit} onClick={(e) => e.stopPropagation()} className="bg-[#FBF9F5] w-full max-w-md p-6 grid gap-4 relative">
            <button type="button" aria-label={t("Fermer")} onClick={() => setOpen(false)} className="absolute top-3 right-3" data-testid="callback-close"><X size={18} /></button>
            {done ? (
              <div data-testid="callback-done"><p className="k-eyebrow">{t("C'est noté")}</p><p className="mt-2">{t("Merci")} {f.name}. {t("L'atelier vous rappelle pour préciser votre projet.")}</p></div>
            ) : (
              <>
                <div><p className="k-eyebrow">{t("Être rappelé")}</p><p className="text-sm text-[#57534E] mt-1">{t("Laissez votre prénom et votre numéro : un membre de l'atelier vous rappelle.")}</p></div>
                <input required minLength={2} className="k-input" placeholder={t("Prénom")} value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="callback-name" />
                <input required type="tel" className="k-input" placeholder={t("Téléphone")} value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} data-testid="callback-phone" />
                <input className="k-input" placeholder={t("Votre besoin (optionnel)")} value={f.need} onChange={(e) => setF({ ...f, need: e.target.value })} data-testid="callback-need" />
                <button className="k-btn" disabled={busy} data-testid="callback-submit">{busy ? "…" : t("Me rappeler")}</button>
              </>
            )}
          </form>
        </div>, document.body)}
    </>
  );
}
